<div class="uni-list-container">
  <div class="list-letters" *ngIf="unisLoaded()">
    <span
      *ngFor="let letterGroup of letterGroups"
      class="list-letter-group"
      (click)="selectList(letterGroup)"
      [class.current]="isSelected(letterGroup)"
      [class.empty]="!isSelectable(letterGroup)"
      >{{ letterGroup }}</span
    >
  </div>
  <p *ngIf="!unisLoaded()" class="loading-unis">Loading University list...</p>
  <div class="results-list" *ngIf="currentList() as currentList">
    <li *ngFor="let uni of currentList" (click)="selectUni(uni)">
      {{ uni.name }}
    </li>
  </div>
  <p *ngIf="unisLoaded() && !(currentList()?.length)" class="no-unis">
    {{ noUnisFoundForLetterMessage }}
  </p>
  <p class="add-links" *ngIf="unisLoaded()">
    <a (click)="doAddUni()">I can't see my college/university in the list</a>
    <a (click)="notAtUni()">I'm not at university</a>
  </p>
</div>
